<template>
  <b-card
    no-body
    class="card-transaction"
  >
    <b-card-header>
      <div>
        <b-card-title>Top Fundraisers</b-card-title>
        <b-card-text class="font-small-2">
          {{ selectedFilter }}
        </b-card-text>
      </div>

      <b-dropdown
        variant="link"
        no-caret
        class="chart-dropdown"
        toggle-class="p-0"
      >
        <template #button-content>
          <feather-icon
            icon="MoreVerticalIcon"
            size="18"
            class="text-body cursor-pointer"
          />
        </template>
        <b-dropdown-item
          v-for="option in filterOptions"
          :key="option"
          @click="selectedFilter = option"
        >
          {{ option }}
        </b-dropdown-item>
      </b-dropdown>
    </b-card-header>

    <!-- body -->
    <b-card-body>
      <div
        v-if="response.isLoading"
        class="d-flex align-items-center justify-content-center h-100"
      >
        <feather-icon
          icon="LoaderIcon"
          class="spinner"
          size="60"
        />
      </div>
      <template v-else>
        <div
          v-for="fundraiser in response.data"
          :key="fundraiser.id"
          class="transaction-item"
        >
          <b-media
            no-body
            class="flex-grow-1 mr-1"
          >
            <b-media-body>
              <div class="d-flex">
                <h6 class="transaction-title text-truncate flex-grow-1">
                  {{ fundraiser.id }}
                </h6>
              </div>
              <small
                class="round font-weight-bold d-inline-block"
                :style="{
                  padding: '2px 6px',
                  fontSize: '8px',
                  backgroundColor: randomColor({
                    luminosity: 'light',
                    seed: `${fundraiser.category.categoryname}`,
                    format: 'rgba',
                    alpha: 0.3,
                  }),
                  color: randomColor({
                    luminosity: 'bright',
                    seed: `${fundraiser.category.categoryname}`,
                  }),
                }"
              >
                {{ fundraiser.category.categoryname }}
              </small>
            </b-media-body>
          </b-media>
          <div class="font-weight-bold text-body-heading">
            ₦{{ fundraiser.raisedAmount.toLocaleString() }}
          </div>
        </div>
      </template>
    </b-card-body>
    <!--/ body -->
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BMedia, BMediaBody, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import randomColor from 'randomcolor'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useApi } from '@core/comp-functions/useApi'

const [res, apiRequest] = useApi('fundraisers/topfundraisers')

const filterOptions = ['Today', 'This Week', 'This Month', 'This Year']

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BMediaBody,
    BDropdown,
    BDropdownItem,
  },
  data() {
    return {
      selectedFilter: filterOptions[3],
      response: res,
    }
  },
  computed: {
    filterOptions: () => filterOptions,
  },
  watch: {
    'response.isFailure': function (isFailure) {
      if (isFailure) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            text: this.response.error || 'Failed to fetch resource',
            icon: 'TrashIcon',
            variant: 'danger',
          },
        })
      }
    },

    selectedFilter: {
      handler(value) {
        apiRequest({
          filter: value.replace(/^This\s+/, '').toUpperCase(),
          offset: 0,
          limit: 5,
        })
      },
      immediate: true,
    },
  },
  methods: {
    randomColor,
  },
}
</script>
